export const whiteSpaceRegExpression = /\S+/;

export const noLeadingWhitespaceRegExpression = /^\S.*$/;

export const yearRegExpression = /^\d{4}$/;
